module.exports = __webpack_public_path__ + "img/1.ab5e69dd.jpg";